import React, { useState } from "react";
import { ComplementParameterRow } from "./ComplementParameterRow";

export const ComplementAreaSection = ({
  area,
  parameters,
  onParameterChange,
  errors = {},
}) => {
  const [isExpanded, setIsExpanded] = useState(true);

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="complement-area-section">
      <div className="complement-area-header" onClick={toggleExpanded}>
        <h3 className="complement-area-title">{area.name}</h3>
        <span className="complement-area-toggle">{isExpanded ? "−" : "+"}</span>
      </div>

      {isExpanded && (
        <div className="complement-area-content">
          <div className="complement-table-header">
            <div className="complement-header-cell complement-header-cell--name">
              Název parametru
            </div>
            <div className="complement-header-cell complement-header-cell--abbreviation">
              Zkr. parametru
            </div>
            <div className="complement-header-cell complement-header-cell--lower-limit">
              Dolní mez
            </div>
            <div className="complement-header-cell complement-header-cell--upper-limit">
              Horní mez
            </div>
            <div className="complement-header-cell complement-header-cell--units">
              Jednotka
            </div>
            <div className="complement-header-cell complement-header-cell--concentration">
              Plazm. koncentrace
            </div>
            <div className="complement-header-cell complement-header-cell--actions"></div>
          </div>

          {parameters.map((parameter, index) => (
            <ComplementParameterRow
              key={parameter.id}
              parameter={parameter}
              onParameterChange={onParameterChange}
              errors={errors}
              isOddRow={index % 2 === 1}
            />
          ))}
        </div>
      )}
    </div>
  );
};
